import { render } from "./EditEvento.vue?vue&type=template&id=28142d3b&scoped=true"
import script from "./EditEvento.vue?vue&type=script&lang=js"
export * from "./EditEvento.vue?vue&type=script&lang=js"

import "./EditEvento.vue?vue&type=style&index=0&id=28142d3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28142d3b"]])

export default __exports__